<template>
  <modal @close="$emit('close')" class-name="pdf-preview-modal-container">
    <template slot="header">
      <h4 class="modal-title">{{ title }}</h4>
      <md-button class="md-simple md-just-icon md-round modal-default-button" @click="$emit('close')">
        <md-icon>clear</md-icon>
      </md-button>
    </template>
    <template slot="body">
      <!-- Bei mehreren Dateien (z.B. eine Pickliste je Lager) Umschalter ueber der Vorschau -->
      <div v-if="files.length > 1" class="pdf-preview-tabs">
        <md-chip v-for="(file, index) in files" :key="file.url" :class="{ 'is-active': index === current }" md-clickable @click="current = index">
          {{ file.title }}
        </md-chip>
      </div>
      <iframe v-if="currentFile" ref="frame" :src="currentFile.url" style="width: 100%; height: 70vh; border: none"></iframe>
    </template>
    <template slot="footer">
      <md-button class="md-primary" :disabled="!currentFile" @click="print"> <md-icon>print</md-icon> {{ $t("pdfPreview.print") }} </md-button>
      <md-button class="md-primary" :href="currentFile && currentFile.url" :download="currentFile && currentFile.fileName" tag="a" :disabled="!currentFile">
        <md-icon>download</md-icon> {{ $t("pdfPreview.download") }}
      </md-button>
      <md-button class="md-secondary" @click="$emit('close')">{{ $t("pdfPreview.close") }}</md-button>
    </template>
  </modal>
</template>

<script>
import { Modal } from "@/components";

/**
 * Vorschau fuer eine oder mehrere PDF-Dateien (Blob-URLs) mit Drucken/Herunterladen.
 * files: [{ title, fileName, url }] - die Blob-URLs gibt der Aufrufer beim Schliessen wieder frei.
 */
export default {
  name: "PdfPreviewModal",
  components: { Modal },
  props: {
    title: { type: String, required: true },
    files: { type: Array, required: true },
  },
  data() {
    return { current: 0 };
  },
  computed: {
    currentFile() {
      return this.files[this.current] || null;
    },
  },
  methods: {
    print() {
      // Blob-URL ist same-origin, daher darf der Druckdialog des iframes direkt aufgerufen werden
      const frame = this.$refs.frame;
      if (!frame || !frame.contentWindow) return;
      frame.contentWindow.focus();
      frame.contentWindow.print();
    },
  },
};
</script>

<style scoped>
.pdf-preview-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 8px;
}
.pdf-preview-tabs .md-chip {
  cursor: pointer;
}
.pdf-preview-tabs .md-chip.is-active {
  /* Theme-Regel von md-chip setzt !important, sonst greift die Markierung nicht */
  background: #9c27b0 !important;
  color: #fff !important;
}
</style>
